<template>
  <div class="apr-alert__title">
    <i class="apr-icon-alert" aria-hidden="true"></i>
    {{ this.name }} is Sold Out for {{ this.checkinDate }} - {{ this.checkoutDate }}.
  </div>
</template>

<script>
export default {
  props: {
    name: String,
    checkinDate: String,
    checkoutDate: String,
  },
}
</script>